import type { ReactNode } from 'react';

import type { TextAlign } from '../../type';
import * as S from './style';

interface CardBackgroundProps {
  children: ReactNode;
  textAlign: TextAlign;
}

export function CardBackground({ children, textAlign }: CardBackgroundProps) {
  return (
    <>
      <S.Wrapper style={{ textAlign: `${textAlign}` }}>{children}</S.Wrapper>
    </>
  );
}
